import React from 'react';

import { Alert, Box, Button, Typography } from '@mui/material';
import { FORM_ERROR } from 'final-form';

import { Field, Form } from '@hrlogics/react-components/form';

import { SSN_MASK } from '@clearverify/constants';
import type { Nullable } from '@clearverify/types';

import { MaskedTextField } from 'src/components/finalForm';
import { FORM_ERROR_KEY, SsnFormField } from 'src/constants/signup';
import type { SxProp } from 'src/types/mui';
import type { SsnFormValues } from 'src/types/signup';

import { ssnFormValidationSchema } from '../utils';

export type SsnFormProps = {
  onSubmit: (formValues: SsnFormValues) => void;
  companyName: Nullable<string>;
};

export const SsnForm: React.FC<SsnFormProps> = ({ onSubmit, companyName }) => {
  return (
    <Box>
      <Box display="flex" alignItems="center">
        <Typography variant="body2" fontSize="24px">
          You've been invited by <b>{companyName}</b> to create your account at Clear Verify
        </Typography>
      </Box>

      <Form<SsnFormValues>
        onSubmit={onSubmit}
        subscription={{ submitting: true, submitErrors: true }}
        containerProps={{ mt: 4 }}
        validationSchema={ssnFormValidationSchema}
      >
        {({ submitting, submitErrors }) => {
          return (
            <React.Fragment>
              <Box>
                <Field
                  name={SsnFormField.ssn}
                  component={MaskedTextField}
                  label="SSN"
                  mask={SSN_MASK}
                  disabled={submitting}
                  fullWidth
                  required
                />
              </Box>

              {submitErrors?.[FORM_ERROR] === FORM_ERROR_KEY.SSN_NOT_FOUND && (
                <Alert severity="error" sx={{ mt: 2 }}>
                  SSN not found. Please check your SSN and try again.
                </Alert>
              )}

              <Box display="flex" justifyContent="center" mt={4}>
                <Button
                  type="submit"
                  sx={submitButtonStyles}
                  disabled={submitting}
                  loading={submitting}
                  size="large"
                  variant="contained"
                >
                  Next step
                </Button>
              </Box>
            </React.Fragment>
          );
        }}
      </Form>
    </Box>
  );
};

const submitButtonStyles: SxProp = {
  px: 5,
};
